import type { RegisterInfo } from '../types/helsenorge.helseregistre.internalapi.entities.entities';

export const getRegisterNavn = (navn: string | null, forkortelse: string | null): string => {
  const navnRegister = navn ?? '';
  return forkortelse && forkortelse !== navn ? `${navn} (${forkortelse})` : navnRegister;
};

export const getRegisterInfoTitle = (registerInfo: RegisterInfo | null): string | null => {
  if (!registerInfo || !registerInfo.navn) {
    return null;
  }
  return getRegisterNavn(registerInfo.navn, registerInfo.forkortelse);
};
